
// import WarningIcon from "../../../assets/svgs/WarningIcon";


export const formErrorMessage = (msg = "Warning") => (
  <span className="text-danger d-flex align-items-center text-xs">
    {/* <WarningIcon className="mr-1" /> */}
    {msg}
  </span>
);
